"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
// import PropTypes from 'prop-types';
// Composants Material UI
var Tabs_1 = __importDefault(require("@mui/material/Tabs"));
var Tab_1 = __importDefault(require("@mui/material/Tab"));
var useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
var styles_1 = require("@mui/material/styles");
// Styles
require("./Panels.css");
// https://stackoverflow.com/questions/19014250/rerender-view-on-browser-resize-with-react
// function debounce(fn, ms) {
//   let timer;
//   return () => {
//     clearTimeout(timer);
//     timer = setTimeout(() => {
//       timer = null;
//       fn.apply(this, arguments);
//     }, ms);
//   };
// }
function debounce(fn, delay) {
    var timer = null;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            timer = null;
            fn.apply(context, args);
        }, delay);
    };
}
;
function Panels(props) {
    // props
    var debug = props.debug, enabled = props.enabled, contents = props.contents, tabs = props.tabs, defaultPanelIndex = props.defaultPanelIndex, tabsLabelOnSmallScreen = props.tabsLabelOnSmallScreen, topContent = props.topContent;
    // state
    var _a = (0, react_1.useState)(defaultPanelIndex), panelDisplayed = _a[0], setPanelDisplayed = _a[1]; // index du panel ouvert (commence a 0)
    // const [dragging, setDragging] = React.useState(false);          // indique qu'un drag est en cours
    // refs
    var panelsWrapper = (0, react_1.useRef)(null);
    var panelActive = (0, react_1.useRef)(null);
    // breakpoints
    var theme = (0, styles_1.useTheme)();
    var isSmallScreen = !!theme ? (0, useMediaQuery_1.default)(theme.breakpoints.down('sm')) : false;
    // autres variables
    var touchStart = {
        clientX: undefined,
        clientY: undefined,
        startTime: undefined
    };
    var touchMove = {
        clientX: undefined,
        clientY: undefined
    };
    var mouseDown = {
        clientX: undefined,
        clientY: undefined,
        startTime: undefined
    };
    var mouseMove = {
        clientX: undefined,
        clientY: undefined
    };
    // Get width and height of the window excluding scrollbars
    var w = document.documentElement.clientWidth;
    var h = document.documentElement.clientHeight;
    (0, react_1.useEffect)(function () {
        var handleDebounceResize = debounce(function () {
            if (!!debug)
                console.log('***** debounced resize', panelDisplayed); // See the cool difference in console
            var neww = document.documentElement.clientWidth;
            if (neww !== w) {
                updatePanel();
                w = neww;
            }
        }, 100); // 100ms
        // const handleResize = () => {
        //   console.log('***** resize',panelDisplayed);
        //   updatePanel();
        // }; // 100ms
        window.addEventListener('resize', handleDebounceResize);
        return function () {
            window.removeEventListener('resize', handleDebounceResize);
        };
    }, []);
    // ---------------------------------------------------------------------------------
    //    Gestion du drag & drop
    // ---------------------------------------------------------------------------------
    function handleTouchStart(e) {
        if (!enabled)
            return;
        // console.log('handleTouchStart',e.targetTouches);
        if (e.targetTouches && e.targetTouches.length > 0) {
            touchStart.clientX = e.targetTouches[0].clientX;
            touchStart.clientY = e.targetTouches[0].clientY;
            touchStart.startTime = new Date().getTime(); // record time when finger first makes contact with surface
            if (panelsWrapper) {
                // panelsWrapper.current.style.transition = 'none';
            }
        }
    }
    function handleTouchMove(e) {
        if (!enabled)
            return;
        if (touchStart.clientX !== undefined) {
            // if (e.cancelable) {
            //  e.preventDefault();
            // }
            // console.log('handleTouchMove',e.targetTouches);
            if (e.targetTouches && e.targetTouches.length > 0) {
                touchMove.clientX = e.targetTouches[0].clientX;
                touchMove.clientY = e.targetTouches[0].clientY;
                // action
                if (panelsWrapper) {
                    var movingDeltaX = touchMove.clientX - touchStart.clientX;
                    var movingDeltaY = touchMove.clientY - touchStart.clientY;
                    // si on swipe top/bottom, on scroll, donc on desactive le swipe left/right
                    // console.log('handleTouchMove',movingDeltaX,movingDeltaY);
                    if (Math.abs(movingDeltaY) > Math.abs(movingDeltaX)) {
                        // console.log('handleTouchMove top/bottom',Math.abs(movingDeltaY) > Math.abs(movingDeltaX));
                    }
                    else {
                        // console.log('handleTouchMove left/right',Math.abs(movingDeltaY) > Math.abs(movingDeltaX));
                        var panelWidthInPx = panelActive === null || panelActive === void 0 ? void 0 : panelActive.current.offsetWidth;
                        var currentTranslate = -(panelDisplayed * panelWidthInPx) + movingDeltaX + 'px';
                        panelsWrapper.current.style.transition = 'none';
                        panelsWrapper.current.style.transform = 'translateX(' + currentTranslate + ')';
                        // console.log('handleMouseMove : movingDeltaX',movingDeltaX,'panelWidthInPx',panelWidthInPx,'Translate',currentTranslate);
                    }
                }
            }
        }
    }
    function handleTouchEnd(e) {
        if (!enabled)
            return;
        // console.log('handleTouchEnd',e.targetTouches);
        if (touchStart.clientX === undefined) {
            // cas swipe sur table-places (overflow-x)
            // console.log('handleTouchEnd : dontswipe, scroll horizontal');
            // reset
            touchStart.clientX = undefined;
            touchStart.clientY = undefined;
            touchStart.startTime = undefined;
            if (panelsWrapper && panelsWrapper.current) {
                panelsWrapper.current.style.removeProperty('transition');
            }
            return;
        }
        // si on a bien swipe
        if (touchMove.clientX !== undefined) {
            var currentDeltaX = touchMove.clientX - touchStart.clientX;
            var currentDeltaY = touchMove.clientY - touchStart.clientY;
            var currentDeltaTime = new Date().getTime() - touchStart.startTime;
            var dir = undefined;
            if (Math.abs(currentDeltaX) > Math.abs(currentDeltaY)) {
                dir = (currentDeltaX < 0) ? 'left' : 'right';
            }
            else {
                dir = (currentDeltaY < 0) ? 'up' : 'down';
            }
            if (debug)
                console.log('Touch swipe ' + dir);
            var swipeType = undefined;
            // if(currentDeltaTime <= 500){
            if (Math.abs(currentDeltaX) >= 150 && Math.abs(currentDeltaY) <= 100) {
                swipeType = dir;
            }
            else if (Math.abs(currentDeltaY) >= 150 && Math.abs(currentDeltaX) <= 100) {
                swipeType = dir;
            }
            // }
            // console.log('handleTouchEnd : dX',currentDeltaX,'dY',currentDeltaY,'dT',currentDeltaTime,'swipe type',swipeType);
            if (debug)
                console.log('Touch effective swipe ' + dir);
            // action
            if (panelsWrapper && panelsWrapper.current) {
                panelsWrapper.current.style.removeProperty('transition');
            }
            var exceedOnRight = swipeType === 'left' && panelDisplayed + 1 >= contents.length;
            var exceedOnLeft = swipeType === 'right' && panelDisplayed - 1 <= -1;
            if (((swipeType !== 'left') && (swipeType !== 'right')) || exceedOnRight || exceedOnLeft) {
                if (debug && exceedOnRight)
                    console.log('Touch swipe too much on right, panel displayed index =', panelDisplayed, ', panels count =', contents.length);
                if (debug && exceedOnLeft)
                    console.log('Touch swipe too much on left, panel displayed index =', panelDisplayed);
                // reset transform
                if (panelsWrapper && panelsWrapper.current) {
                    panelsWrapper.current.style.removeProperty('transform');
                }
            }
            else {
                swipePanel(swipeType, 1);
                // console.log('SWIPE',swipeType);
                if (e.cancelable) {
                    e.preventDefault();
                }
            }
            // if((swipeType==='left') || (swipeType==='right')){
            //   // verifie qu'on est pas aux limites
            //   if(swipeType==='left' && panelDisplayed+1 >= contents.length){
            //     // reset transform
            //     if(panelsWrapper && panelsWrapper.current){
            //       panelsWrapper.current.style.removeProperty('transform');
            //     }
            //   }else if(swipeType==='right' && panelDisplayed-1 <= -1){
            //     // reset transform
            //     if(panelsWrapper && panelsWrapper.current){
            //       panelsWrapper.current.style.removeProperty('transform');
            //     }
            //   }else{
            //     swipePanel(swipeType,1);
            //     // console.log('SWIPE',swipeType);
            //     if (e.cancelable) {
            //       e.preventDefault();
            //     }
            //   }
            // }else{
            //   // reset transform
            //   if(panelsWrapper && panelsWrapper.current){
            //     panelsWrapper.current.style.removeProperty('transform');
            //   }
            // }
        }
        // reset
        touchStart.clientX = undefined;
        touchStart.clientY = undefined;
        touchStart.startTime = undefined;
        touchMove.clientX = undefined;
        touchMove.clientY = undefined;
    }
    function handleMouseDown(e) {
        // console.log('handleMouseDown',e,enabled);
        if (!enabled)
            return;
        mouseDown.clientX = e.clientX;
        mouseDown.clientY = e.clientY;
        mouseDown.startTime = new Date().getTime(); // record time when finger first makes contact with surface
        if (panelsWrapper) {
            // panelsWrapper.current.style.transition = 'none';
        }
    }
    function handleMouseMove(e) {
        if (!enabled)
            return;
        if (mouseDown.clientX !== undefined) {
            // console.log('handleMouseMove',e);
            mouseMove.clientX = e.clientX;
            mouseMove.clientY = e.clientY;
            // action
            if (panelsWrapper) {
                var movingDeltaX = mouseMove.clientX - mouseDown.clientX;
                var panelWidthInPx = panelActive.current.offsetWidth;
                var currentTranslate = -(panelDisplayed * panelWidthInPx) + movingDeltaX + 'px';
                panelsWrapper.current.style.transition = 'none';
                panelsWrapper.current.style.transform = 'translateX(' + currentTranslate + ')';
                // console.log('handleMouseMove : movingDeltaX',movingDeltaX,'panelWidthInPx',panelWidthInPx,'Translate',currentTranslate);
            }
        }
    }
    function handleMouseUp(e) {
        if (!enabled)
            return;
        // console.log('handleMouseUp',e);
        if (mouseDown.clientX === undefined) {
            // cas swipe sur table-places (overflow-x)
            // console.log('handleMouseUp : dontswipe, scroll horizontal');
            // reset
            mouseDown.clientX = undefined;
            mouseDown.clientY = undefined;
            mouseDown.startTime = undefined;
            if (panelsWrapper && panelsWrapper.current) {
                panelsWrapper.current.style.removeProperty('transition');
            }
            return;
        }
        var currentDeltaX = mouseMove.clientX - mouseDown.clientX;
        var currentDeltaY = mouseMove.clientY - mouseDown.clientY;
        var currentDeltaTime = new Date().getTime() - mouseDown.startTime;
        var dir = undefined;
        if (Math.abs(currentDeltaX) > Math.abs(currentDeltaY)) {
            dir = (currentDeltaX < 0) ? 'left' : 'right';
        }
        else {
            dir = (currentDeltaY < 0) ? 'up' : 'down';
        }
        if (debug)
            console.log('Mouse swipe ' + dir);
        var swipeType = undefined;
        // if(currentDeltaTime <= 300){
        if (Math.abs(currentDeltaX) >= 150 && Math.abs(currentDeltaY) <= 100) {
            swipeType = dir;
        }
        else if (Math.abs(currentDeltaY) >= 150 && Math.abs(currentDeltaX) <= 100) {
            swipeType = dir;
        }
        else {
            // console.log('handleMouseUp : not enough horizontal');
        }
        // }else{
        //   console.log('handleMouseUp : not enough quick');
        // }
        // console.log('handleMouseUp : dX',currentDeltaX,'dY',currentDeltaY,'dT',currentDeltaTime,'dir',dir,'swipe',swipeType);
        if (debug)
            console.log('Mouse effective swipe ' + dir);
        // reset
        mouseDown.clientX = undefined;
        mouseDown.clientY = undefined;
        mouseDown.startTime = undefined;
        // action
        if (panelsWrapper && panelsWrapper.current) {
            panelsWrapper.current.style.removeProperty('transition');
        }
        var exceedOnRight = swipeType === 'left' && panelDisplayed + 1 >= contents.length;
        var exceedOnLeft = swipeType === 'right' && panelDisplayed - 1 <= -1;
        if (((swipeType !== 'left') && (swipeType !== 'right')) || exceedOnRight || exceedOnLeft) {
            if (debug && exceedOnRight)
                console.log('Mouse swipe too much on right, panel displayed index =', panelDisplayed, ', panels count =', contents.length);
            if (debug && exceedOnLeft)
                console.log('Mouse swipe too much on left, panel displayed index =', panelDisplayed);
            // reset transform
            if (panelsWrapper && panelsWrapper.current) {
                panelsWrapper.current.style.removeProperty('transform');
            }
        }
        else {
            swipePanel(swipeType, 1);
            // console.log('SWIPE',swipeType);
            e.preventDefault();
        }
        // if((swipeType==='left') || (swipeType==='right')){
        //   // verifie qu'on est pas aux limites
        //   if(swipeType==='left' && panelDisplayed+1 >= contents.length){
        //     // reset transform
        //     if(panelsWrapper && panelsWrapper.current){
        //       panelsWrapper.current.style.removeProperty('transform');
        //     }
        //   }else if(swipeType==='right' && panelDisplayed-1 <= -1){
        //     // reset transform
        //     if(panelsWrapper && panelsWrapper.current){
        //       panelsWrapper.current.style.removeProperty('transform');
        //     }
        //   }else{
        //     swipePanel(swipeType,1);
        //     // console.log('SWIPE',swipeType);
        //     e.preventDefault();
        //   }
        // }else{
        //   // reset transform
        //   if(panelsWrapper && panelsWrapper.current){
        //     panelsWrapper.current.style.removeProperty('transform');
        //   }
        // }
    }
    // ---------------------------------------------------------------------------------
    //    Switch panel
    // ---------------------------------------------------------------------------------
    // swipe de plusieurs crans dans une direction
    // direction : direction du swipe
    // gap >= 1
    // NE FONCTIONNE QUE AU CRAN 1 : TODO ajouter le translateX courant
    function swipePanel(direction, gap) {
        // console.log('swipePanel',direction,', gap',gap);
        if (!direction)
            return;
        if (gap < 1)
            return;
        var panelWidthInPx = 0;
        var nextTranslate = '0px';
        if (direction === 'left') {
            // verifie qu'on est pas aux limites
            if (panelDisplayed + gap >= contents.length)
                return;
            if (panelsWrapper) {
                panelWidthInPx = panelActive.current.offsetWidth;
                nextTranslate = -((panelDisplayed + 1) * panelWidthInPx * gap) + 'px';
                panelsWrapper.current.style.transform = 'translateX(' + nextTranslate + ')';
                // console.log('swipePanel to left : nextTranslate',nextTranslate);
            }
            setPanelDisplayed(panelDisplayed + gap);
        }
        else if (direction === 'right') {
            // verifie qu'on est pas aux limites
            if (panelDisplayed - gap <= -1)
                return;
            if (panelsWrapper) {
                panelWidthInPx = panelActive.current.offsetWidth;
                nextTranslate = -((panelDisplayed - 1) * panelWidthInPx * gap) + 'px';
                panelsWrapper.current.style.transform = 'translateX(' + nextTranslate + ')';
                // console.log('swipePanel to right : nextTranslate',nextTranslate);
            }
            setPanelDisplayed(panelDisplayed - gap);
        }
    }
    // va vers n'importe quel index (commence a 0)
    function goTo(index) {
        // console.log('swipePanelTo',index);
        if (index < 0 || index > contents.length - 1)
            return;
        var panelWidthInPx = 0;
        var nextTranslate = '0px';
        if (panelsWrapper) {
            panelWidthInPx = panelActive.current.offsetWidth;
            nextTranslate = -(panelWidthInPx * index) + 'px';
            panelsWrapper.current.style.transform = 'translateX(' + nextTranslate + ')';
            // console.log('goTo : index',index);
        }
        setPanelDisplayed(index);
    }
    function selectPanel(index) {
        // console.log('selectPanel',index,', current is',panelDisplayed);
        goTo(index);
    }
    // met a jour le translateX
    function updatePanel() {
        goTo(panelDisplayed);
    }
    // tabs classes
    var classWithTabs = '';
    var classWithTabsType = '';
    if (tabs && tabs.length > 0) {
        classWithTabs = ' with-tabs';
        classWithTabsType = ' with-tabs-single';
        if (!isSmallScreen) {
            for (var _i = 0, tabs_1 = tabs; _i < tabs_1.length; _i++) {
                var tab = tabs_1[_i];
                if (!!tab.icon) {
                    classWithTabsType = ' with-tabs-double';
                    break;
                }
            }
        }
        else {
            if (tabsLabelOnSmallScreen)
                for (var _b = 0, tabs_2 = tabs; _b < tabs_2.length; _b++) {
                    var tab = tabs_2[_b];
                    if (!!tab.icon) {
                        classWithTabsType = ' with-tabs-double';
                        break;
                    }
                }
        }
    }
    var TopElement = topContent;
    // if(!!debug) console.log('panelDisplayed',panelDisplayed);
    var ratioTositionLeftTopElement = 20 * (contents.length - 1 - panelDisplayed) / (contents.length - 1);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: 'panels panels-total-' + contents.length + ' panel-active-' + panelDisplayed + classWithTabs + classWithTabsType, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd, onMouseDown: handleMouseDown, onMouseMove: handleMouseMove, onMouseUp: handleMouseUp }, { children: [tabs ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "panels-navigation" }, { children: [(0, jsx_runtime_1.jsx)(Tabs_1.default, __assign({ value: panelDisplayed, variant: "fullWidth", "aria-label": "Menu" }, { children: tabs.map(function (tab, index) {
                            // en mobile, on affiche que les icons
                            // au-dessus on affiche icons + labels
                            if (isSmallScreen && !tabsLabelOnSmallScreen)
                                return (0, jsx_runtime_1.jsx)(Tab_1.default, { "aria-label": tab.label, icon: tab.icon, id: index + '', onClick: function (e) { return selectPanel(index); }, className: tab.className }, index);
                            return (0, jsx_runtime_1.jsx)(Tab_1.default, { label: tab.label, icon: tab.icon, id: index + '', onClick: function (e) { return selectPanel(index); }, className: tab.className }, index);
                        }) }), void 0), TopElement ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "panels-topelement", style: { left: ratioTositionLeftTopElement + 'vw' } }, { children: TopElement }), void 0)) : null] }), void 0)) : null, (0, jsx_runtime_1.jsx)("div", __assign({ className: "panels-wrapper", ref: panelsWrapper }, { children: contents.map(function (panel, index) {
                    var Element = panel; // Note: variable name _must_ start with a capital letter 
                    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: 'panel panel-' + index + (panelDisplayed === index ? ' panel-active' : ''), ref: panelDisplayed === index ? panelActive : undefined }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "panel-frame" }, { children: Element }), void 0) }), index));
                }) }), void 0)] }), void 0));
}
exports.default = Panels;
//# sourceMappingURL=Panels.js.map